module.exports = __webpack_public_path__ + "img/2x2-narrowing.67e28ad9.png";